export default {
  ALPHA: 'alpha',
  ACCELERATE_HOME_PAGE: 'accelerateHomePage',
  DEALER_INVENTORY: 'dealerInventory',
  DHS: 'dhs',
  ELOT: 'elot',
  HOT_CAR: 'hotcar',
  LISTING: 'listing',
  MY_ATC_SAVED_CAR: 'myATCsavedcar',
  OTHER_VDP: 'otherVDP',
  PREVIOUSLY_VIEWED: 'PreviouslyViewed',
  RECOMMENDATIONS: 'recommendations',
  SIMILAR_INVENTORY: 'similar',
  SPOTLIGHT: 'spotlight',
  SUPLEMENTAL: 'supplemental'
};